module.exports = __webpack_public_path__ + "img/svg/background-user-rankings-mobile.30c4ed1a629421288ae1f91384f9f6fe.svg";